/* GENERATED from succession/brands/veyla/shared/vy-offer.js by
   build-listicle-theme.py. Do not edit this file: edit the shared one
   and rebuild, or this lander quietly keeps selling old prices.
   A REPRICING IS NOT DONE until this lander is rebuilt and repushed. */
/* ============================================================
   VEYLA | the offer, in one place

   Consumed by THREE surfaces now: the review PDP (?view=veyla-lab), the
   homepage (?view=veyla-home), and the Kaching-matched PDP on the sandbox
   product /products/veyla™-hair-growth-serum-copy (same veyla-lab template,
   this module just picks the right ladder). Tier prices, the Seal plan, the
   subscribe default and the shape of the add-to-cart payload live here and
   nowhere else, so a repricing is one file to change and no chance of fixing
   one surface and forgetting the others.

   DOM-free on purpose. No selectors, no markup, no listeners, no side
   effects beyond defining window.VY_OFFER. That is what makes it safe to
   drop underneath a page that is already live on the client's theme.

   Every number below was read off the live store and, where the store and
   its apps disagree, verified against the real cart with pdp/cart-probe.py
   (lab, 2026-08-01) and the scratchpad probe (copy product, 2026-08-06).
   Where they disagree, the CART wins: it is what the customer is charged.
   ============================================================ */
(() => {
  /* Every price string on both surfaces is built here. When the Vitals
     currency layer (vy-currency.js) has a conversion for this visitor,
     money() speaks it; otherwise plain USD. Checked at call time because
     the conversion lands seconds after first paint, and the pages listen
     for 'vy:currency' to re-render when it does. */
  const money = c =>
    (window.VY_CC && window.VY_CC.fmt(c)) || '$' + (c / 100).toFixed(2);

  /* WHICH SURFACE. The sandbox product carries its own Kaching deal, so it gets
     its own ladder.

     THIS BROKE ONCE, LIVE, AND THE FIX IS THE LESSON. The original test was
     /hair-growth-serum-copy/ against the pathname. The client renamed the
     product in their admin, the "-copy" suffix disappeared, the test stopped
     matching, and ?view=veyla-lab on that product silently fell through to the
     LAB branch: the REAL product's variant id, LAB prices, and no Kaching
     property on the line. Nothing errored. omar-os #883, found 2026-08-07.

     Matching on a handle the client can rename is the actual design fault, so
     there are now three ways in, most explicit first:

       window.VY_SURFACE = 'copy'   set by a page that KNOWS which product it
                                    sells. Standalone landers must use this:
                                    their own pathname says nothing at all.
       ?offer=copy                  the local prototype and the harness
       the pathname                 any handle containing "hair-growth-serum",
                                    with or without the suffix. Safe against
                                    the real product, whose handle is
                                    "growth-serum" and does not contain it. */
  const IS_COPY = (typeof window !== 'undefined' && window.VY_SURFACE === 'copy') ||
    (typeof location !== 'undefined' &&
      (/hair-growth-serum/.test(decodeURIComponent(location.pathname)) ||
       /[?&]offer=copy\b/.test(location.search)));

  /* ----------------------------------------------------------
     LAB: the original review surfaces, on the real product.
     Untouched 2026-08-06: same numbers, same behaviour, plus the card text
     (cardTitle / cardSub / flag), which used to live only in the PDP markup
     and now lives here so the copy surface can re-skin the same three cards.
     The strings are byte-identical to what the markup has always said.
     ---------------------------------------------------------- */
  const LAB = {
    /* The one real variant. Grow:Turn Ampoule, $49.95 / RRP $79.95. */
    SERUM: { id: 50715117191335, rrpCents: 7995 },

    /* Subscription. Seal Subscriptions, read off the live product 2026-08-01:
       exactly one plan exists, "Deliver every 4 weeks" at 20%. So every tier
       renews on that cycle whatever its size, which is wrong for the 4 and 6
       tube tiers.

       byTier is the upgrade path: create 8 / 12 / 24 week plans in Seal, drop
       their ids in here, and the ladder starts renewing at the rate it is
       actually consumed. Until then the copy says four weeks, because it is
       four weeks, and nothing here invents a cadence the store cannot honour. */
    SUB: {
      pct: 20,
      plan: { id: 3371696295, everyDays: 28, label: 'every 4 weeks' },
      byTier: {}    // b2g2: { id: 0, everyDays: 84, label: 'every 12 weeks' }
    },
    SUB_ENABLED: true,
    SUB_TERMS_PRICE: true,

    /* SUBSCRIBE STARTS ON, per Osama's review 2026-08-03, and this is the flag
       both original surfaces read.

       KNOWN CHECKOUT GAP, accepted by Omar the same day: Kaching's free tubes
       still do not apply when a Seal selling plan is on the line. Re-probed
       2026-08-03: B2G2 subscribed rings up $159.84 against the $59.96 the
       ladder advertises, and B2G2 one-time now rings up $87.95 (their Kaching
       config moved since 2026-08-01). The client's team owns the app fix.
       omar-os #647 / #648. */
    SUB_DEFAULT: true,

    /* Ladder bases repriced 2026-08-04 on the manager's instruction (Slack,
       omar-os #792): shown-with-20% prices must land on $69.95 (b2g2) and
       $89.95 (b3g3). Bases are those targets / 0.8: b2g2 8744 matches
       Kaching's own deal-bar config exactly (87.44 was chosen for the same
       reason), b3g3 is 11244 NOT Kaching's 11245 because 11245*.8 rounds to
       $89.96 and the instruction says $89.95.
       compareCents is always tubes x $79.95 RRP. */
    TIERS: {
      b1g1: { tubes: 2, totalCents: 4995,  compareCents: 15990, label: 'Buy 1 Get 1',
              cardTitle: 'Buy 1 Get 1 Free', cardSub: '2 tubes · 2 months',            flag: 'Visible Results' },
      b2g2: { tubes: 4, totalCents: 8744,  compareCents: 31980, label: 'Buy 2 Get 2',
              cardTitle: 'Buy 2 Get 2 Free', cardSub: '4 tubes · the full growth cycle', flag: 'Lasting Hair Support' },
      b3g3: { tubes: 6, totalCents: 11244, compareCents: 47970, label: 'Buy 3 Get 3',
              cardTitle: 'Buy 3 Get 3 Free', cardSub: '6 tubes · two months more cover', flag: 'Complete Hair Restoration' }
    },
    /* Omar, 2026-08-07: the ladder now opens on the two-tube offer rather than
       the four. Shared by the PDP and the homepage, so both surfaces move
       together and neither can drift into preselecting a different bar. */
    TIER_DEFAULT: 'b1g1',

    /* The comparison table's per-tube claim and the in-page product links.
       Surface data, because the copy surface prices differently and must not
       link back to the real PDP mid-pitch. */
    COST_CLAIM: '$18.74 a tube on the four-tube offer',
    PRODUCT_URL: '/products/growth-serum'
  };

  /* ----------------------------------------------------------
     COPY: the sandbox product, matching ITS Kaching deal exactly.
     Read off the product page's kaching-bundles-deal-block-settings and
     probed against the real cart 2026-08-06:

       bar 1  "Buy 1"            qty 1  configured $49.95  cart $49.95
       bar 2  "Buy 1, Get 1 FREE" qty 2  configured $49.93  cart $49.95  MOST POPULAR, preselected
       bar 3  "Buy 2, Get 4 FREE" qty 6  configured $99.93  cart $99.95  BIGGEST SAVINGS

     Bars 2 and 3 ring up 2c over their configured amounts because Kaching's
     priceRounding ".95" overrides them (same fault the lab ladder hit on
     B3G3). The cart wins, so the totals below are the PROBED ones: this page
     never advertises under what she pays.

     The discount is Kaching's cart-level quantity rule and it fires on a
     plain single-line add of the full unit count.

     SUBSCRIPTION, added 2026-08-06 after the client's team put the sandbox
     product on the same Seal "Subscribe & save" rule as the real one. Omar's
     instruction: mirror the client's Kaching widget EXACTLY, same structure,
     same displayed pricing. Their widget shows every bar 20% off with .95
     rounding while the refills box is ticked (its default), so subscribed
     displays are 39.95 / 39.95 / 79.95: that is subTotalCents, and with it
     present tierTotal goes mode-dependent (toggle off = the one-time bases).

     THE DISCOUNTS DO STACK, resolved 2026-08-06 (late): they only stack when
     the line carries Kaching's own __kaching_bundles property, which their
     widget attaches and which KACHING below reproduces (captured off their
     real PDP's actual /cart/add POST). Probed with the property, every cell
     of the matrix rings EXACTLY what the widget shows: subscribed
     39.95 / 39.95 / 79.95, one-time 49.95 / 49.95 / 99.95. The earlier
     "non-stacking" finding was an artifact of probing without the property.

     Still open (omar-os #855): what a bundle subscription RENEWS at. The
     contract's per-delivery price comes from Seal (39.96 a tube), and
     whether Kaching's discount survives into renewal orders is unverified,
     so the sub terms line still names the cadence and never an amount
     (SUB_TERMS_PRICE off) until the client's team confirms. */
  const COPY = {
    SERUM: { id: 51104449822887, rrpCents: 7995 },
    SUB: {
      pct: 20,
      plan: { id: 3371696295, everyDays: 28, label: 'every 4 weeks' },
      byTier: {}
    },
    SUB_ENABLED: true,
    SUB_DEFAULT: true,
    SUB_TERMS_PRICE: false,
    TIERS: {
      b1g1: { tubes: 1, totalCents: 4995, subTotalCents: 3995, compareCents: 7995,  label: 'Buy 1',
              cardTitle: 'Buy 1',             cardSub: '1 tube · starter plan',              flag: '' },
      b2g2: { tubes: 2, totalCents: 4995, subTotalCents: 3995, compareCents: 15990, label: 'Buy 1 Get 1 Free',
              cardTitle: 'Buy 1, Get 1 FREE', cardSub: '2 tubes · visible results',          flag: 'Most popular' },
      b3g3: { tubes: 6, totalCents: 9995, subTotalCents: 7995, compareCents: 47970, label: 'Buy 2 Get 4 Free',
              cardTitle: 'Buy 2, Get 4 FREE', cardSub: '6 tubes · complete hair restoration', flag: 'Biggest savings' }
    },
    TIER_DEFAULT: 'b2g2',
    COST_CLAIM: '$16.66 a tube on the six-tube offer',
    /* renamed by the client 2026-08-07: the "-copy" handle 404s now */
    PRODUCT_URL: '/products/veyla%E2%84%A2-hair-growth-serum',

    /* Kaching's deal identity, read off kaching-bundles-deal-block-settings
       on the live product 2026-08-06. The copy product now sits on the SAME
       deal as the real one (deal zUTf), so a repricing on their side shows
       up here by breaking the probe, not by silently charging different
       amounts: the property pins the bar, the cart function prices it.
       pp is the copy PRODUCT id (not the variant). */
    KACHING: {
      deal: 'zUTf',
      v: 'e7f00275-ed86-4177-bb2e-f26363b2f36d',
      pp: 11108512694439,
      bids: {
        b1g1: '9c4596da-88f3-4385-9117-f5e6c60274c8',
        b2g2: 'b139a58a-5618-49ad-a24e-a699aaa49a9d',
        b3g3: '3fc0dcd9-0c3f-4c05-85fd-54c493f39b9f'
      }
    }
  };

  const S = IS_COPY ? COPY : LAB;
  const { SERUM, SUB, SUB_ENABLED, SUB_DEFAULT, SUB_TERMS_PRICE, TIERS, TIER_DEFAULT, COST_CLAIM, PRODUCT_URL, KACHING } = S;

  /* Thinning zone. Cosmetic only: it aims the routine copy and labels the
     cart line so support knows where she is treating. No variant changes,
     because there is only one variant. Same on every surface. */
  const ZONES = {
    hairline: { label: 'Hairline', dot: '#DE5504',
      note: 'Temples and the front edge respond first, because they go dormant first. Press along the edge and work back two inches.' },
    part:     { label: 'Part line', dot: '#C2410C',
      note: 'Run the brush straight down the part, then make a second part an inch over and do that one too. Widening starts at the edges.' },
    crown:    { label: 'Crown', dot: '#9A3412',
      note: 'The hardest spot to see and the easiest to under-treat. Use a mirror for the first week until your hand knows where it is.' },
    overall:  { label: 'All over', dot: '#EA7B2E',
      note: 'Four passes: hairline, part, crown, then the sides. One tube still covers a month, because it is one minute, not ten pumps.' }
  };
  const ZONE_DEFAULT = 'hairline';

  const planFor  = key => SUB.byTier[key] || SUB.plan;
  const subCents = c => Math.round(c * (100 - SUB.pct) / 100);

  /* Both surfaces hold their own { zone, tier, sub } state object and hand it
     in here, rather than this module holding state that two pages would then
     have to keep in sync.

     The 20% applies in BOTH modes (Osama, 2026-08-03): toggling subscribe off
     keeps the discounted ladder, the switch only controls the selling plan.
     The copy surface IS mode-dependent, the way the client's widget is: a
     tier that carries subTotalCents shows that with the refills box ticked
     and its plain base with it off. Lab tiers carry no subTotalCents, so
     they keep the always-discounted behaviour to the byte. */
  const tierTotal = (tierKey, sub) => {
    const t = TIERS[tierKey];
    if (t.subTotalCents != null) return sub ? t.subTotalCents : t.totalCents;
    return subCents(t.totalCents);
  };

  /* The line under the buybox while subscribe is on. The lab surface names
     the renewal amount because there it is true. The copy surface names only
     the cadence: its bundle renewals bill at Seal's per-tube plan price, not
     the bundle price, so any amount printed here would be wrong (#855). */
  const subTerms = (tierKey, sub) => SUB_TERMS_PRICE
    ? `Renews ${planFor(tierKey).label} at ${money(tierTotal(tierKey, sub))}. Skip or cancel any time before the next charge.`
    : `Refills land ${planFor(tierKey).label}. Skip or cancel any time before the next charge.`;

  const perTube = (tierKey, sub) =>
    Math.round(tierTotal(tierKey, sub) / TIERS[tierKey].tubes);

  /* THE single add-to-cart payload, for VYDrawer.add().

     PORT NOTE: the buy-N-get-N discount is a cart-level Kaching rule that
     counts units. Add the full unit count as ONE line and let the rule price
     it. Do not send only the paid quantity. Probed true on both products. */
  const addPayload = state => {
    const t = TIERS[state.tier];
    const plan = planFor(state.tier);
    /* state.zone is optional. The PDP asks her where she is thinning, so the
       answer rides along as a line property and support knows where to aim the
       routine card. The homepage does not ask, and a homepage that stamps
       "Hairline" on the order because that is the default is telling support
       something the customer never said. No picker, no property. */
    const zone = state.zone ? ZONES[state.zone] : null;
    const item = {
      id: SERUM.id,
      quantity: t.tubes,
      // display hints: used by the prototype drawer, ignored by Shopify
      unitCents: perTube(state.tier, state.sub),
      // the tier total rides on the line so the prototype subtotal matches the
      // button to the cent even when it does not divide evenly
      lineCents: tierTotal(state.tier, state.sub),
      meta: zone ? `${zone.label} · ${t.label}` : t.label,
      planLabel: state.sub ? plan.label : undefined
    };
    if (zone) item.properties = { _zone: zone.label };
    if (state.sub && plan.id) item.selling_plan = plan.id;
    /* Kaching's discount function only stacks the subscription 20% onto the
       bundle price when the line carries this property: it names the deal,
       the bar and the plan adjustment, exactly the way their own widget's
       add does (captured 2026-08-06). Without it the cart falls back to the
       bare quantity break and overcharges every subscribed bundle. */
    if (KACHING) {
      const kb = { deal: KACHING.deal, pp: KACHING.pp, main: true, v: KACHING.v, bid: KACHING.bids[state.tier] };
      if (state.sub && plan.id) kb.sellingPlan = { id: plan.id, priceAdjustment: { type: 'percentage', value: SUB.pct } };
      item.properties = Object.assign(item.properties || {}, { __kaching_bundles: JSON.stringify(kb) });
    }
    return [item];
  };

  /* Is the top of the ladder actually the best deal? Both surfaces say so out
     loud when it is not, and both recompute it here rather than trusting
     their own copy, so the admission disappears by itself the day the client
     reprices. (On the copy surface six tubes ARE the cheapest per tube, so
     the note stays down.) */
  const tier3IsWorseValue = sub => perTube('b3g3', sub) > perTube('b2g2', sub);

  window.VY_OFFER = {
    SERUM, SUB, SUB_ENABLED, SUB_DEFAULT, TIERS, TIER_DEFAULT, ZONES, ZONE_DEFAULT,
    COST_CLAIM, PRODUCT_URL, KACHING,
    money, planFor, subCents, tierTotal, perTube, subTerms, addPayload, tier3IsWorseValue
  };
})();
